import { jsx as u } from "../../../_virtual/jsx-runtime.mjs";
import f from "react";
import { reoFormItemError as N, reoFormItemErrorItem as b } from "../css/ReoFormItem.mjs";
import d from "../../../depend/classnames/index.mjs";
import p from "../hooks/useDebounce.mjs";
import { toErrorEntity as s, getErrorClassByStatus as y } from "./common.mjs";
const x = (r) => {
  const { help: t, helpStatus: m, fieldId: n } = r, h = f.useMemo(() => d(
    N,
    "reo-basic-form-item-error",
    r.className
  ), [r.className]), a = p(r.errors ?? []), i = p(r.warnings ?? []), l = f.useMemo(() => t != null ? [s(t, "help", m)] : [
    ...a.map((e, o) => s(e, "error", "error", o)),
    ...i.map(
      (e, o) => s(e, "warning", "warning", o)
    )
  ], [t, m, a, i]), c = {};
  return n && (c.id = `${n}_help`), l.length ? /* @__PURE__ */ u(
    "div",
    {
      className: h,
      ...c,
      children: l.map((e) => {
        const {
          key: o,
          error: E,
          errorStatus: g
        } = e;
        return /* @__PURE__ */ u(
          "div",
          {
            className: d(
              b,
              "reo-basic-form-item-error-item",
              y(g)
            ),
            role: "alert",
            children: E
          },
          o
        );
      })
    }
  ) : null;
};
export {
  x as CompErrorList,
  x as default
};
//# sourceMappingURL=ErrorList.mjs.map
